<script lang="ts" setup>
  import { computed } from 'vue'
  import { useDemoStore } from '@/store/Demo'

  const store = useDemoStore()

  const gameDemoSrc = computed(
    () =>
      `https://${
        import.meta.env.VITE_APP_ENV === 'live' ? '' : import.meta.env.VITE_APP_ENV + '-'
      }www.nexon.com/maplestory/game/play`
  )
</script>
<template>
  <div v-if="store.isActive" class="demo-overlay" @click.self="store.setActive(false)">
    <div class="demo-overlay-close" @click="store.setActive(false)">✕</div>
    <div class="demo-overlay-container">
      <iframe
        width="100%"
        height="100%"
        :src="gameDemoSrc"
        title="MapleStory | Ren Demo"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .demo-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    &-container {
      position: relative;
      width: 100%;
      height: 90%;
      max-width: 100%;
      background: #000;
    }

    &-close {
      position: absolute;
      top: pxToRem(5);
      right: pxToRem(10);
      opacity: 0.5;
      color: white;
      font-size: pxToRem(30);
      width: pxToRem(40);
      height: pxToRem(40);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.3s;
      z-index: 10000;

      &:hover {
        opacity: 1;
      }
    }

    iframe {
      display: block;
    }
  }
</style>
